{% block rz_profil_feld %}
<div class="rz-profil-feld">
    <div v-for="achse in achsen" :key="achse.schluessel" class="rz-profil-feld__zeile">
        <span class="rz-profil-feld__name">{{ achse.name }}</span>

        <div class="rz-profil-feld__punkte" role="group" :aria-label="achse.name">
            <button v-for="stufe in [0, 1, 2, 3, 4, 5]"
                    :key="stufe"
                    type="button"
                    class="rz-profil-feld__punkt"
                    :class="{ 'is-an': stufe > 0 && stufe <= werte[achse.schluessel], 'is-null': stufe === 0 }"
                    :disabled="disabled"
                    :title="stufe === 0 ? 'kommt nicht vor' : stufe + ' von 5'"
                    @click="setze(achse.schluessel, stufe)">
                <span>{{ stufe === 0 ? '–' : stufe }}</span>
            </button>
        </div>
    </div>

    <div class="rz-profil-feld__fuss">
        <span v-if="istLeer" class="rz-profil-feld__hinweis">
            Kein Profil gesetzt – die Artikelseite zeigt dann keine Geschmacksbalken.
        </span>
        <button v-else type="button" class="rz-profil-feld__leeren" :disabled="disabled" @click="leeren">
            Profil leeren
        </button>
    </div>
</div>
{% endblock %}
